import { render, staticRenderFns } from "./ParseArticle.vue?vue&type=template&id=7887d602"
import script from "./ParseArticle.vue?vue&type=script&lang=js"
export * from "./ParseArticle.vue?vue&type=script&lang=js"
import style0 from "./ParseArticle.vue?vue&type=style&index=0&id=7887d602&prod&lang=scss"
import style1 from "./ParseArticle.vue?vue&type=style&index=1&id=7887d602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports